import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  // Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  // ListGroup,
  Accordion,
  Card,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import { getPlazasVacantes } from "../../redux/seleccionContratacion/plazas_vacantes/actions";
//import { getFactor } from "../../../redux/evaluacion_desempenio/Factor/actions";
import { get_tasks_descriptors } from "../../redux/tasks/actions";
import { Link, useHistory } from "react-router-dom";
import LinkDescriptor from "../../components/evaluacion_desempenio/LinkDescriptor";
import { getGeneralInfo } from "../../redux/descriptorsProfiles/GeneralInfo/actions";
import {
  deleteFormEvalCompetenciaQuestion,
  editFormEvalCompetenciaQuestion,
  getFormEvalCompeteciaQuestionById,
  getFormEvalCompetencias,
  saveFormEvalCompetenciaQuestion,
} from "../../redux/evaluacion_desempenio/formularioEval_Comp_Question/actions";
import TableFormEvalQuestionsComponent from "../../components/evaluacion_desempenio/TableFormEvalQuestions";
import QuestionCompetencyComponent from "../../components/evaluacion_desempenio/QuestionCompetency";
import { getPesoCompetencias } from "../../redux/evaluacion_desempenio/pesoCompetencia/actions";
import {
  getMetricaCompetencias,
  deleteMetricaCompetencias,
  editMetricaCompetencias,
  saveMetricaCompetencias,
} from "../../redux/evaluacion_desempenio/metricaCompetencia/actions";
import { Label } from "@material-ui/icons";

// Importante:  Esta pantalla es el formulario de evaluciones por COMPETENCIAS.

const EvalFormQuestions = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);

  const [count, setCount] = useState(0);
  const [error, setError] = useState("");
  const [formError, setFormError] = useState("");
  const [timer, setTimer] = useState(null);
  const dispatch = useDispatch();
  const onShowSidebar = () => setShow(show ? false : true);
  const [index, setIndex] = useState(0);
  const [_funcion, setFuncion] = useState(false);
  const [_viewMessege, setViewMessege] = useState(false);
  const [_continue, setContinue] = useState(true);
  const [alphabet, setAlphabet] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [show, setShow] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [arrayGrados, setArrayGrados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [functionSelected, setFunctionSelected] = useState(null);
  // const [validatedFunction, setValidatedFunction] = useState(false);
  const [positionSelected, setPositionSelected] = useState(null);
  const [filter, setFilter] = useState("");
  const [resetFunction, setResetFunction] = useState(false);
  const {
    loaderEvalFormCompetencyQuestion,
    evalFormCompetencyQuestion,
    evalFormCompetencyQuestionState,
    evalFormCompetencyQuestionFalla,
    saveLoaderEvalFormCompetencyQuestion,
    evalFormCompetencyQuestionFormError,
    nota,
    desempeño,
  } = useSelector((store) => store.evalFormCompetencyQuestion);
  const history = useHistory();
  const [data, setData] = useState([]);

  const {
    loaderPesoCompetencia,
    pesoCompetencia,
    pesoCompetenciaFalla,
    saveLoaderPesoCompetencia,
    pesoCompetenciaFormError,
    pesoCompetencias,
  } = useSelector((store) => store.pesoCompetencia);

  const {
    loaderMetricaCompetencia,
    metricaCompetencia,
    metricaCompetenciaFalla,
    saveLoaderMetricaCompetencia,
    metricaCompetenciaFormError,
    ultimoRegistro,
    loaderUltimoRegistro,
  } = useSelector((store) => store.metricaCompetencia);

  //const _index = props.pesoCompetencia.data.findIndex((e) => e.competencia === props.item.id);

  const _getCompetencia = (filt = filter) =>
    dispatch(
      getPesoCompetencias({
        tipo_busqueda: "competencia_id",
        filter: filt,
      })
    );

  // const _getFormEvalCompetencias = () => {
  //     dispatch(getFormEvalCompetencias({ id: parseInt(props.match.params.id) }));
  //   };

  useEffect(() => {
    // getPesoCompetencias();
    _getCompetencia();
    _getMetricaCompetencias();
    // _getFormEvalCompetencias();
    dispatch(getFormEvalCompetencias({ id: parseInt(props.match.params.id) }));
  }, []);

  var _arrayGrados = [];
  useEffect(() => {
    if (evalFormCompetencyQuestion) {
      evalFormCompetencyQuestion.map((item, index) => {
        let arrayTemp = [];
        item.map((_item, _index) => {
          
          if (_item && _item?.idMetrica) {
            arrayTemp.push({
              grado: _item?.idMetrica,
              index: index,
            });
          } else {
            arrayTemp.push("");
          }
        });
        _arrayGrados.push(arrayTemp);
        setArrayGrados(_arrayGrados);
      });
    }
  }, [evalFormCompetencyQuestion]);

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.currentTarget.value);
    _getMetricaCompetencias(e.currentTarget.value);
  };

  const _getMetricaCompetencias = () =>
    dispatch(
      getMetricaCompetencias({
        tipo_busqueda: "periodicidad_id",
        filter: parseInt(props.match.params.periodicidad),
      })
    );

  {
    /* let arrayGrados = [];

  useEffect(() => {
    if (evalFormCompetencyQuestion) {
      evalFormCompetencyQuestion.map((item) => {
        arrayGrados.push("");
      });
      console.log("Data del eval form", evalFormCompetencyQuestion);
    }
  }, [evalFormCompetencyQuestion]);

*/
  }

  const onSubmit = () => {
    // console.log("arreglo", arrayGrados);
    const req = {
      respuesta_competencia: [],
    };
    arrayGrados.map((item, index) => {
      item.map((_item, _index) => {
        if (evalFormCompetencyQuestion[index][_index] && _item.grado) {
          req.respuesta_competencia.push({
            metrica_competencia: parseInt(_item.grado),
            encabezado: parseInt(props.match.params.id),
            evaluacion_plantilla_competencia:
              evalFormCompetencyQuestion[index][_index].idPlantilla,
          });
        }
      });
    });
    dispatch(
      editFormEvalCompetenciaQuestion(
        req,
        parseInt(props.match.params.id),
        index,
        setShowFormModal
      )
    );
    setIsEdit(true);
  };

  

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 mx-3 d-flex flex-wrap justify-content-start align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              {" "}
            </Row>{" "}
            <Button
              onClick={() => history.goBack()}
              variant="link"
              className="font-weight-bold text-dark"
            >
              <i className="material-icons">arrow_back</i>
            </Button>
            <h6 className="font-weight-bold text-uppercase">
              Formulario de evaluación por competencia
            </h6>
          </div>
          <Col sm="12" md="12">
            <hr />
          </Col>
          <div className="my-4 mx-4 border-left border-warning">
            <Alert variant="light">
              <p>
                Seleccione el grado que define mejor la competencia desarrollada
                según el desempeño del colaborador, donde 1=Inferior, 2=Inferior
                al Promedio, 3=Promedio, 4=Superior al promedio, 5=Superior.
              </p>
            </Alert>
          </div>
          {/* separacion */}
          <Col md="12" className="px-0 mx-auto">
            <Card
              className="border border-muted rounded shadow-sm bg-white"
              style={{ border: "1px solid #ced4da" }}
            >
              <Card.Header className="card-crear text-muted text-uppercase d-flex flex-wrap justify-left-between align-items-left text-justify">
                <h6>Preguntas por competencia</h6>
                <div className="ml-auto d-flex flex-wrap justify-content-between align-items-center">
                  <b className="text-light text-uppercase">
                    {nota !== null ? nota + "%" : "no evaluado"}
                    {desempeño && desempeño !== "" ? " - " + desempeño : ""}
                  </b>
                </div>
              </Card.Header>
              <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                <Row className="justify-content-sm-center align-items-center flex-nowrap">
                  <Col md="12">
                    <Row className="mb-0">
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr>
                            <th>COMPETENCIA</th>
                            <th>DEFINICIÓN</th>
                            <th>PREGUNTAS</th>
                            <th>GRADO</th>
                          </tr>
                        </thead>
                        {loaderEvalFormCompetencyQuestion ||
                        loaderMetricaCompetencia ? (
                          <div className="d-flex justify-content-center">
                            <Spinner
                              animation="border"
                              role="status"
                              className="d-flex justify-content-center"
                            />
                          </div>
                        ) : (
                          evalFormCompetencyQuestion && (
                            <>
                              <tbody>
                                {evalFormCompetencyQuestion.map(
                                  (item, index) => (
                                    <>
                                      {/* <tr>
                                      <th rowspan="6" scope="col">
                                        {pesoCompetencia
                                          ? item.list_competencia[0].nombre
                                          : ""}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th
                                        rowspan="5"
                                        scope="col"
                                        style={{ maxWidth: "400px" }}
                                      >
                                        {pesoCompetencia
                                          ? item.list_competencia[0].descripcion
                                          : ""}
                                      </th>
                                    </tr> */}
                                      {/* <TableFormEvalQuestionsComponent
                                      encabezado_id={props.match.params.id}
                                      competencia={item}
                                      //  arrayGrados={arrayGrados}
                                      index={index}
                                      isSubmit={isSubmit}
                                    /> */}
                                      <tr>
                                        <td rowspan="6" scope="col">
                                          {item[0] && item[0].nombreCompetencia
                                            ? item[0].nombreCompetencia
                                            : ""}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          rowspan="5"
                                          scope="col"
                                          // style={{ maxWidth: "400px" }}
                                        >
                                          <div style={{ width: "350px" }}>
                                            {item[0] &&
                                            item[0].descripcionCompetencia
                                              ? item[0].descripcionCompetencia
                                              : ""}
                                          </div>
                                        </td>
                                      </tr>
                                      {[1, 2, 3, 4].map((_item, _index) => (
                                        <>
                                          <tr>
                                            {item[_index] && item[_index]?.idMetrica ||
                                            !isEdit ? (
                                              <th>
                                                <div
                                                  style={{ minWidth: "300px" }}
                                                >
                                                  {/* item[_index] &&
                                                item[_index].pregunta ?
                                                item[_index].pregunta : "" */}
                                                  {item[_index] &&
                                                  item[_index].pregunta
                                                    ? item[_index].pregunta
                                                    : ""}
                                                </div>
                                              </th>
                                            ) : (
                                              <th width="50%" bgcolor="#96C0DF">
                                                <div
                                                  style={{ minWidth: "300px" }}
                                                >
                                                  {item[_index] &&
                                                  item[_index].pregunta
                                                    ? item[_index].pregunta
                                                    : ""}
                                                </div>
                                              </th>
                                            )}

                                            {item[_index] && item[_index].idMetrica ||
                                            !isEdit ? (
                                              <td>
                                                <div style={{ width: "140px" }}>
                                                  <>
                                                    {!item[_index] ? (
                                                      ""
                                                    ) : (
                                                      <>
                                                        {(props.match.params
                                                          .evaluationType &&
                                                          parseInt(
                                                            props.match.params
                                                              .evaluationType
                                                          ) === 2) ||
                                                        !evalFormCompetencyQuestionState ? (
                                                          <>
                                                            <div>
                                                              {item[_index] &&
                                                              item[_index]
                                                                .idMetrica &&
                                                              metricaCompetencia &&
                                                              metricaCompetencia.data
                                                                ? metricaCompetencia.data.find(
                                                                    (e) =>
                                                                      item[
                                                                        _index
                                                                      ]
                                                                        .idMetrica ===
                                                                      e.id
                                                                  ).grado
                                                                : "0"}
                                                            </div>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <Form.Group
                                                              as={Col}
                                                            >
                                                              <Form.Control
                                                                column
                                                                sm="12"
                                                                md="12"
                                                                as="select"
                                                                id="grado"
                                                                name="nombre"
                                                                className="col rounded-pill"
                                                                disabled={
                                                                  isLoading
                                                                }
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  let arrayT =
                                                                    arrayGrados;
                                                                  arrayT[index][
                                                                    _index
                                                                  ] = {
                                                                    grado:
                                                                      e
                                                                        .currentTarget
                                                                        .value,
                                                                    index:
                                                                      index,
                                                                  };
                                                                  setIsLoading(
                                                                    true
                                                                  );
                                                                  if (timer) {
                                                                    clearTimeout(
                                                                      timer
                                                                    );
                                                                    setTimer(
                                                                      null
                                                                    );
                                                                  }
                                                                  setTimer(
                                                                    setTimeout(
                                                                      () => {
                                                                        setArrayGrados(
                                                                          arrayT
                                                                        );
                                                                        setIsLoading(
                                                                          false
                                                                        );
                                                                      },
                                                                      500
                                                                    )
                                                                  );
                                                                }}
                                                                defaultValue={
                                                                  item[_index]
                                                                    ? item[
                                                                        parseInt(
                                                                          _index
                                                                        )
                                                                      ]
                                                                        .idMetrica
                                                                    : ""
                                                                }
                                                              >
                                                                <option>
                                                                  Seleccione un
                                                                  grado
                                                                </option>
                                                                {metricaCompetencia &&
                                                                  metricaCompetencia.data.map(
                                                                    (
                                                                      metric
                                                                    ) => (
                                                                      <option
                                                                        key={
                                                                          metric.id
                                                                        }
                                                                        value={
                                                                          metric.id
                                                                        }
                                                                      >
                                                                        {
                                                                          metric.grado
                                                                        }
                                                                      </option>
                                                                    )
                                                                  )}
                                                              </Form.Control>

                                                              {loaderEvalFormCompetencyQuestion && (
                                                                <Col sm={1}>
                                                                  <Spinner
                                                                    animation="border"
                                                                    size="sm"
                                                                  />
                                                                </Col>
                                                              )}
                                                              {!!error && (
                                                                <Col>
                                                                  <small className="text-danger">
                                                                    **
                                                                    {error}
                                                                  </small>
                                                                </Col>
                                                              )}
                                                            </Form.Group>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                  </>
                                                </div>
                                              </td>
                                            ) : (
                                              <td bgcolor="#96C0DF">
                                                <div style={{ width: "140px" }}>
                                                  <>
                                                    {!item[_index] ? (
                                                      ""
                                                    ) : (
                                                      <>
                                                        {(props.match.params
                                                          .evaluationType &&
                                                          parseInt(
                                                            props.match.params
                                                              .evaluationType
                                                          ) === 2) ||
                                                        !evalFormCompetencyQuestionState ? (
                                                          <>
                                                            <div>
                                                              {item[_index] &&
                                                              item[_index]
                                                                .idMetrica &&
                                                              metricaCompetencia &&
                                                              metricaCompetencia.data
                                                                ? metricaCompetencia.data.find(
                                                                    (e) =>
                                                                      item[
                                                                        _index
                                                                      ]
                                                                        .idMetrica ===
                                                                      e.id
                                                                  ).grado
                                                                : "0"}
                                                            </div>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <Form.Group
                                                              as={Col}
                                                            >
                                                              <Form.Control
                                                                column
                                                                sm="12"
                                                                md="12"
                                                                as="select"
                                                                id="grado"
                                                                name="nombre"
                                                                className="col rounded-pill"
                                                                disabled={
                                                                  isLoading
                                                                }
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  let arrayT =
                                                                    arrayGrados;
                                                                  arrayT[index][
                                                                    _index
                                                                  ] = {
                                                                    grado:
                                                                      e
                                                                        .currentTarget
                                                                        .value,
                                                                    index:
                                                                      index,
                                                                  };
                                                                  setIsLoading(
                                                                    true
                                                                  );
                                                                  if (timer) {
                                                                    clearTimeout(
                                                                      timer
                                                                    );
                                                                    setTimer(
                                                                      null
                                                                    );
                                                                  }
                                                                  setTimer(
                                                                    setTimeout(
                                                                      () => {
                                                                        setArrayGrados(
                                                                          arrayT
                                                                        );
                                                                        setIsLoading(
                                                                          false
                                                                        );
                                                                      },
                                                                      500
                                                                    )
                                                                  );
                                                                }}
                                                                defaultValue={
                                                                  item[_index]
                                                                    ? item[
                                                                        parseInt(
                                                                          _index
                                                                        )
                                                                      ]
                                                                        .idMetrica
                                                                    : ""
                                                                }
                                                              >
                                                                <option>
                                                                  Seleccione un
                                                                  grado
                                                                </option>
                                                                {metricaCompetencia &&
                                                                  metricaCompetencia.data.map(
                                                                    (
                                                                      metric
                                                                    ) => (
                                                                      <option
                                                                        key={
                                                                          metric.id
                                                                        }
                                                                        value={
                                                                          metric.id
                                                                        }
                                                                      >
                                                                        {
                                                                          metric.grado
                                                                        }
                                                                      </option>
                                                                    )
                                                                  )}
                                                              </Form.Control>

                                                              {loaderEvalFormCompetencyQuestion && (
                                                                <Col sm={1}>
                                                                  <Spinner
                                                                    animation="border"
                                                                    size="sm"
                                                                  />
                                                                </Col>
                                                              )}
                                                              {!!error && (
                                                                <Col>
                                                                  <small className="text-danger">
                                                                    **
                                                                    {error}
                                                                  </small>
                                                                </Col>
                                                              )}
                                                            </Form.Group>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                  </>
                                                </div>
                                              </td>
                                            )}
                                          </tr>
                                        </>
                                      ))}
                                    </>
                                  )
                                )}
                              </tbody>
                            </>
                          )
                        )}
                      </Table>
                    </Row>
                  </Col>
                </Row>
                {loaderEvalFormCompetencyQuestion ||
                (props.match.params.evaluationType &&
                  parseInt(props.match.params.evaluationType) === 2) ||
                !evalFormCompetencyQuestionState ? null : (
                  <>
                    <Button
                      className="rounded-pill mt-0"
                      disabled={saveLoaderEvalFormCompetencyQuestion}
                      variant="yellow"
                      type="button"
                      onClick={
                        () => onSubmit()
                        // setIsSubmit(true)
                      }
                    >
                      {saveLoaderEvalFormCompetencyQuestion && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          align-items="right"
                        />
                      )}
                      Guardar evaluacion
                    </Button>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default EvalFormQuestions;
